export default {
  data() {
    return {
      columnsInfo1: [
        //被执行人
        {
          title: '序号',
          width: 100,
          dataIndex: 'order',
          key: 'order',
          fixed: 'left',
          customRender: (text, record, index) => {
            return (
              (this.pageData.current - 1) * this.pageData.pageSize + index + 1
            )
          },
        },
        {
          title: '被执行人姓名/名称',
          dataIndex: 'name',
          key: 'name',
        },
        {
          title: '立案时间',
          dataIndex: 'filingTime',
          key: 'filingTime',
        },
        {
          title: '案号',
          dataIndex: 'caseNo',
          key: 'caseNo',
        },
        {
          title: '执行法院',
          dataIndex: 'executionCourt',
          key: 'executionCourt',
        },
        {
          title: '执行标的（元）',
          dataIndex: 'objectOfExecution',
          key: 'objectOfExecution',
        },
      ],
      columnsInfo2: [
        //失信被执行人
        {
          title: '序号',
          width: 100,
          dataIndex: 'order',
          key: 'order',
          fixed: 'left',
          customRender: (text, record, index) => {
            return (
              (this.pageData.current - 1) * this.pageData.pageSize + index + 1
            )
          },
        },
        {
          title: '被执行人姓名/名称',
          dataIndex: 'name',
          key: 'name',
        },
        {
          title: '立案时间',
          dataIndex: 'filingTime',
          key: 'filingTime',
        },
        {
          title: '案号',
          dataIndex: 'caseNo',
          key: 'caseNo',
        },
        {
          title: '执行法院',
          dataIndex: 'executionCourt',
          key: 'executionCourt',
        },
        {
          title: '省份',
          dataIndex: 'province',
          key: 'province',
        },
        {
          title: '被执行人履行情况',
          dataIndex: 'performanceStatus',
          key: 'performanceStatus',
        },
        {
          title: '操作',
          scopedSlots: { customRender: 'action' },
          width: 100,
          fixed: 'right',
        },
      ],
      columnsInfo3: [
        //开庭公告
        {
          title: '序号',
          width: 100,
          dataIndex: 'order',
          key: 'order',
          fixed: 'left',
          customRender: (text, record, index) => {
            return (
              (this.pageData.current - 1) * this.pageData.pageSize + index + 1
            )
          },
        },
        {
          title: '开庭日期',
          dataIndex: 'publishDate',
          key: 'publishDate',
        },
        {
          title: '案号',
          dataIndex: 'caseNumber',
          key: 'caseNumber',
        },
        {
          title: '案由',
          dataIndex: 'causeOfAction',
          key: 'causeOfAction',
        },
        {
          title: '当事人',
          dataIndex: 'party',
          key: 'party',
        },
        {
          title: '法院',
          dataIndex: 'courtName',
          key: 'courtName',
        },
        {
          title: '审理法庭',
          dataIndex: 'trialCourt',
          key: 'trialCourt',
        },
        {
          title: '审理法官',
          dataIndex: 'trialJudge',
          key: 'trialJudge',
        },
      ],
    }
  },
}
